module.exports = __webpack_public_path__ + "4fbd07501bea413dbfc220ea0dd84b58.png";